export let API_KEY = 'AIzaSyDQCcsTusYTJ_p8GwcifuTCk60GZ8Z6WmU';
export let minHistoryDate = (new Date()) - 31536000000;